// | ------------------------------------------------------------------------
// | Bootstrap - Collapse
// | ------------------------------------------------------------------------ 

import { Collapse } from "bootstrap";

// | ------------------------------------------------------------------------ 


// Collapse that starts closed on Mobiles but automatically changes to open on Desktops

var showCollapses = function(){    

    var mobileCollapses = document.querySelectorAll('.mobile-collapse');

    mobileCollapses.forEach(function(e){        
        var mobileCollapse = Collapse.getOrCreateInstance(e, {toggle: false});
        mobileCollapse.show();
    });

}

var hideCollapses = function(){    

    var mobileCollapses = document.querySelectorAll('.mobile-collapse');

    mobileCollapses.forEach(function(e){        
        var mobileCollapse = Collapse.getOrCreateInstance(e, {toggle: false});
        mobileCollapse.hide();
    });

}


// Create a condition that targets viewports at least 768px wide
const mediaQuery = window.matchMedia('(min-width: 768px)');

function checkMobileCollapse(e) {
  if (e.matches) {
    showCollapses();
  }else{
    hideCollapses();
  }
}

// Register event listener
mediaQuery.addEventListener("change", () => {
  checkMobileCollapse(mediaQuery);
});

// Initial check
checkMobileCollapse(mediaQuery);


